var lightbox = new SimpleLightbox('.growl-component-gallery__item a', {});
